/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx, css } from '@emotion/react'

import { EuiFlexGroup, EuiFlexItem, EuiText, useEuiTheme } from '@elastic/eui'

import type { FunctionComponent, ReactNode } from 'react'

interface Props {
  children?: ReactNode
  formLabel?: boolean
  help: ReactNode
}

const useStyles = () => {
  const { euiTheme } = useEuiTheme()

  return {
    content: css`
      width: 400px;
    `,
    help: css`
      width: 400px;
      margin-top: ${euiTheme.size.xxl} !important;
    `,
  }
}

export const CuiFormSection: FunctionComponent<Props> = ({
  formLabel = true,
  help,
  children,
  ...rest
}) => {
  const styles = useStyles()
  let helpColumn

  if (help) {
    helpColumn = (
      <EuiFlexItem grow={false} css={formLabel ? styles.help : undefined}>
        <EuiText size='s'>{help}</EuiText>
      </EuiFlexItem>
    )
  }

  return (
    <EuiFlexGroup gutterSize='xl' {...rest}>
      <EuiFlexItem grow={false} css={styles.content}>
        {children}
      </EuiFlexItem>

      {helpColumn}
    </EuiFlexGroup>
  )
}
